export const module = {
  info: {
    name: 'voip-testing-panel',
    caption: 'voip testing panel',
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
}

export default module
